export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '98f074c5-1cf1-48e6-b684-c7c9ea58bd76';
export const MODAL_CLOSE_SEC = 2.5;
